// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C0ot","comment":"styles_comment__3TG34"};